import { formatDateTimeUnit } from './format-date-time-unit';

const isValidDate = (date: unknown): date is Date =>
  date instanceof Date && !Number.isNaN(date.getTime());

export function getDateTimeValueByDate(value?: unknown) {
  const safeValue = isValidDate(value) ? value : new Date();

  const year = safeValue.getFullYear();
  const month = formatDateTimeUnit(safeValue.getMonth() + 1);
  const day = formatDateTimeUnit(safeValue.getDate());

  const hours = formatDateTimeUnit(safeValue.getHours());
  const minutes = formatDateTimeUnit(safeValue.getMinutes());

  // convert to ISO format with current time zone
  const date = `${year}-${month}-${day}`;
  const time = `${hours}:${minutes}`;

  return { date, time };
}
